export const ROUTES = {
  HOME: '',
  QUOTE_EDIT: 'edit/:id',
  NOT_FOUND: 'not-found',
  AUTHORIZER: 'authorizer'
};
